
import { createSlice } from '@reduxjs/toolkit';

export const privilegeSlice = createSlice({
    name: "privilege",
    initialState: {
        modalStatus: false,
        selectedPrivilege: null
    },
    reducers: {
        openAddPrivilegeModal: (state) => {
        state.modalStatus = "add";
        },
        openEditPrivilegeModal: (state, action) => {
        state.modalStatus = "edit";
        state.selectedPrivilege = action.payload;
        },
        openDeletePrivilegeModal: (state, action) => {
        state.modalStatus = "delete";
        state.selectedPrivilege = action.payload;
        },
        closePrivilegeModal: (state) => {
        state.modalStatus = false;
        state.selectedPrivilege = null;
        }
    }
});

export const {
    openAddPrivilegeModal,
    openEditPrivilegeModal,
    openDeletePrivilegeModal,
    closePrivilegeModal
} = privilegeSlice.actions;

export default privilegeSlice.reducer;